// extracted by mini-css-extract-plugin
export default {"root":"EmptyMessage-root-fcae0e843321cbcbf0487ebbb91fa17b"};